import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import { ChoiceQuestion_ExamSurveyAnswerFragment } from 'generated/graphql'
import { ExamContext } from '@app.feature/exam/context/ExamContext'
import SUBJECT_MAX_QUESTION_COUNT from '@app.feature/exam/gsat2024-2/constants/subjectMaxQuestionCount'
import { changeOnlyNumber } from 'utils/inputUtils'
import { ExamSurveyFormFields, Question6Type } from '../schema/examSurveySchema'

export interface InputAnswerItemDesktopProps {
  answer: ChoiceQuestion_ExamSurveyAnswerFragment
  questionId: string
  questionSeq: number
  inputQuestionSubject: keyof Question6Type
}

const InputAnswerItemDesktop = ({
  answer,
  questionId,
  inputQuestionSubject,
  questionSeq,
}: InputAnswerItemDesktopProps) => {
  const { handleCheckReservation } = useContext(ExamContext)
  const { setValue, register, resetField } =
    useFormContext<ExamSurveyFormFields>()
  const inputQuestionFormKey =
    `question${questionSeq}` as keyof ExamSurveyFormFields['inputQuestions']

  const handleChangeQuestion = (e) => {
    handleCheckReservation({
      onReservated: () => {
        changeOnlyNumber(e)
        if (
          Number(e.target.value) <=
          SUBJECT_MAX_QUESTION_COUNT[inputQuestionSubject]
        ) {
          setValue(
            `inputQuestions.${inputQuestionFormKey}.${inputQuestionSubject}`,
            {
              answerId: answer.id,
              questionId,
            },
          )
        } else {
          resetField(
            `inputQuestions.${inputQuestionFormKey}.${inputQuestionSubject}`,
          )
        }
      },
      onNotReservated: () => {
        resetField(
          `inputQuestions.${inputQuestionFormKey}.${inputQuestionSubject}`,
        )
      },
    })
  }

  return (
    <StyledWrapper>
      <label>{answer.content}</label>
      <input
        placeholder="못푼 문제 수 입력"
        className="answer-input"
        inputMode="decimal"
        maxLength={2}
        {...register(
          `inputQuestions.${inputQuestionFormKey}.${inputQuestionSubject}.numericAnswer`,
          {
            onChange: handleChangeQuestion,
          },
        )}
      />
      <p>개/{SUBJECT_MAX_QUESTION_COUNT[inputQuestionSubject]}</p>
    </StyledWrapper>
  )
}

export default InputAnswerItemDesktop

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;

  > .answer-input {
    width: 150px;
    height: 50px;
    border-radius: 8px;
    border: solid 1px #ddd;
    background-color: #fff;
    padding-left: 16px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.64px;
    text-align: left;
    color: #333;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &::placeholder {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.64px;
      text-align: left;
      color: #999999;
    }
  }

  > label {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.64px;
    color: #333;
    margin-right: 16px;
  }
  > p {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.64px;
    color: #333;
    margin-left: 10px;
  }
`
